export const CLAIM_OFFER = 'CLAIM_OFFER';
export const SET_OFFER_SEEN = 'SET_OFFER_SEEN';
export const SET_OFFER_SEEN_SUCCESS = 'SET_OFFER_SEEN_SUCCESS';
export const SET_SUB_OFFER_NOTIFICATION_SHOWN = 'SET_SUB_OFFER_NOTIFICATION_SHOWN';
